
export default function(api: GlobalFetch) {
  return async function(values, roomId: string, calendarId: string) {
    const response = await api.fetch(
      `/api/v2/pricemulti/room/id_room/${roomId}/id_calendar/${calendarId}/`,
      {
        body: JSON.stringify({integrations: values.integrations, id_room: roomId, id_calendar: calendarId}),
        method: 'POST',
      },
    )
    if (response.ok) {
      return response.status.toString()
    } else {
      const json = await response.json()
      throw new Error(JSON.stringify(json))
    }
  }
}
